import Lookup from './lookup.js';

export default class BodySubPart extends Lookup
{
    
}
